var oHeaderMainMenu, oPromoCollectionSection;

function init() {
  var oCollapsibleSections = document.querySelector('.cc-horizontal-tabs'),
      oFilterBar = document.querySelector('.shopify-app-block .boost-sd-left'),
      oCarouselContainers = document.querySelectorAll('#main-content carousel-slider');
  document.querySelectorAll('.slideshow__slide').forEach(function(elem) {
    elem.addEventListener('click', function() {
        let href = this.querySelector('a').href;
        if(href !== null && href !== '') {
            location.href = href;
        }
    }, false);
});
  oPromoCollectionSection = document.querySelector('.cc-collection-promo-cards .promo-origin-container');

  oHeaderMainMenu = document.querySelector('.cc-header .main-menu .main-menu__disclosure');
 /* if (window.innerWidth > 1023) {
      oHeaderMainMenu.classList.add('desktop-menu');
  } else if (window.innerWidth < 1024) {
      oHeaderMainMenu.classList.add('mobile-menu');
  }
 
  window.addEventListener('resize', mainMenuMobileSwap);
  window.addEventListener('scroll', mainMenuMobileSwap);*/
  
  document.querySelector('.cc-header .laptop-menu-toggle').addEventListener('click', toggleLaptopMainMenu);
  if(oCollapsibleSections) setCollapsibleItems(oCollapsibleSections);
  if(oPromoCollectionSection) addCollectionPromoCard(oPromoCollectionSection);
 
  // breaks arrows
  /*
  if(oCarouselContainers.length > 0) {
    setTimeout(function() {
      moveArrowsOutsideAllCarousels(document.querySelectorAll('#main-content carousel-slider'));
    }, 2000);
  }
  */
  setCarouselAlternativeNav();
  preOpenMainMenuMobileItems();
  setMobileHeaderBotMenu();
  
  // filter page add indicator to tabs if item is active within. Load in is dependant on app so if on right page keep checking till loaded.
  if(document.querySelector('.cc-apps .shopify-app-block')) {
    setFilterPageActiveIndicators();
    addOnSaleClass();
    //changeFilterTitles();
  }

  // only for black friday
  //setBlackFridayProductBanners();
}

function addOnSaleClass() {
  var oPriceContainer = document.querySelectorAll('.boost-sd__filter-block .boost-sd__product-item .boost-sd__product-price-content');
  
  for (let i = 0; oPriceContainer[i]; i++) {
    if (oPriceContainer[i].querySelector('.boost-sd__format-currency--price-compare')) {
      oPriceContainer[i].classList.add('on-sale');
    }
  } 
  setTimeout(addOnSaleClass, 1000)
}

function changeFilterTitles() {
  var oFilterSortLabel = document.querySelector('.cc-apps .boost-sd__filter-block .boost-sd__sorting-label'),
      oFilterOptionsLabel = document.querySelector('.cc-apps .boost-sd__filter-block .boost-sd__filter-tree-toggle-button-title');

  if (oFilterSortLabel && oFilterOptionsLabel) {
    oFilterSortLabel.innerText = 'Sort by';
    oFilterOptionsLabel.innerText = 'Filter'; 
  } else {
    //setTimeout(changeFilterTitles, 500);
  }
  setTimeout(changeFilterTitles, 500);
}

function setMobileHeaderBotMenu() {
    var oSearchIcon = document.querySelector('.cc-header header .header__icons .js-show-search'),
        oAccountIcon = document.querySelector('.cc-header header .header__icons .text-current'),
        oCartIcon = document.querySelector('.cc-header header .header__icons #cart-icon'),
        oMobileHeaderBar = document.getElementById('mobile-header-bar'),
        oMobileHeaderBarInner = document.createElement('div');

    // set search
    if (oSearchIcon) {
      var oBarSearchIcon = document.createElement('div'),
          oSearchField = document.createElement('input'),
          oSearchButton = document.createElement('a'),
          oSearchContainer = document.createElement('div');

      
      oBarSearchIcon.classList = oSearchIcon.classList;
      oBarSearchIcon.classList.add('search-icon');
      oBarSearchIcon.innerHTML = oSearchIcon.innerHTML;
      oSearchContainer.classList.add('search-container');
      oSearchButton.href = '#';
      oSearchButton.innerText = 'Search';

      // search events
      oBarSearchIcon.addEventListener('click', toggleMobileBotMenuSearchBar);
      oSearchField.addEventListener('input', function (e) {
        document.querySelector('#mobile-header-bar .search-container a').href = '/search?q=' + this.value;
      });
      
      oSearchField.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          document.querySelector('#mobile-header-bar .search-container a').click();
        }
      });

      oSearchContainer.append(oSearchField);
      oSearchContainer.append(oSearchButton);
      oMobileHeaderBar.append(oSearchContainer);
      oMobileHeaderBarInner.append(oBarSearchIcon);
    }
    
    // set account
    if (oAccountIcon) {
      var oBarAccountIcon = oAccountIcon.cloneNode(true);
      oBarAccountIcon.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0777/2746/5754/files/Account-white.png?v=1701699273';
      
      oMobileHeaderBarInner.append(oBarAccountIcon);
    }

    // set cart
    if (oCartIcon) {
      var oBarCartIcon = oCartIcon.cloneNode(true),
          oMobileCartContainer = document.createElement('div');

      oMobileCartContainer.id = 'mobileCartContainer';
      oBarCartIcon.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0777/2746/5754/files/Cart-white_e0998bc9-bbca-4142-bc0b-e9dd452f2598.png?v=1701699273';
      oMobileCartContainer.append(oBarCartIcon);
      
      oMobileHeaderBarInner.append(oMobileCartContainer); 
    }

    oMobileHeaderBarInner.classList.add('inner');
    oMobileHeaderBar.append(oMobileHeaderBarInner);
    
    itemAddedToCart()
}

function itemAddedToCart() {
  var oCartBubble = document.querySelector('cart-icon-bubble'),
      oMobileCartContainer = document.getElementById('mobileCartContainer'),
      oBarCartIcon = document.querySelector('.cc-header header .header__icons #cart-icon').cloneNode(true);
    
  oBarCartIcon.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0777/2746/5754/files/Cart-white_e0998bc9-bbca-4142-bc0b-e9dd452f2598.png?v=1701699273';
  oMobileCartContainer.innerHTML = '';
  oMobileCartContainer.append(oBarCartIcon);
  
  setTimeout(itemAddedToCart, 1000);
}

function toggleMobileBotMenuSearchBar() {
  document.querySelector('#mobile-header-bar .search-container').classList.toggle('active');
}

function preOpenMainMenuMobileItems() {
  var oMobileMenuItems = document.querySelectorAll('header .main-menu .js-mega-nav .js-mega-nav details');

  for (let i = 0; oMobileMenuItems[i]; i++) {
    oMobileMenuItems[i].setAttribute("open", "");
  } 
}

    function setBlackFridayProductBanners() {
        setInterval(function () {
            let oFilterSaleBannersCon = document.querySelectorAll('.boost-sd__product-label');
            let oProductSaleBannersCon = document.querySelectorAll('.product-label--sale');

            swapBannersToBlackFriday(oFilterSaleBannersCon);
            swapBannersToBlackFriday(oProductSaleBannersCon);
        }, 1000)
    }

    function swapBannersToBlackFriday(bannerCon) {
        bannerCon.forEach((banner) => {
            let oSaleBanners = banner.querySelector('.boost-sd__product-label-text span');
            if (oSaleBanners && oSaleBanners.innerHTML.includes('Sale')) {
                banner.classList.add('black-friday');
                oSaleBanners.classList.add('black-friday');
                oSaleBanners.innerHTML = 'Black Friday';
            } else if (bannerCon[i].innerText.includes('Sale')) {
                banner.classList.add('black-friday');
                banner.innerHTML = 'Black Friday';
            }
        });
    }

function setCarouselAlternativeNav() {
  var oNavBlock = document.querySelectorAll('.cc-image-carousel-tabs .alternative-nav-container')  

  for (let i = 0; i < oNavBlock.length; i++) {
    oNavBlock[i].children[0].addEventListener('click', runCarouselAlternativeNav);
    oNavBlock[i].children[1].addEventListener('click', runCarouselAlternativeNav);
  }

}

function runCarouselAlternativeNav() {
  if (this.classList.contains('nav-left')) {
    this.parentElement.parentElement.querySelectorAll('.slider-nav__btn')[1].click();
  } else {
    this.parentElement.parentElement.querySelectorAll('.slider-nav__btn')[0].click();
  }
}

function moveArrowsOutsideAllCarousels(item) {
  for (let i = 0; i < item.length; i++) {
    var oNavContainer = item[i].querySelector('.slider-nav'),
      oContainerToPlaceIn = item[i].parentElement;

    oNavContainer.remove();
    oContainerToPlaceIn.insertBefore(oNavContainer, oContainerToPlaceIn.firstChild);
  }
}

function setFilterPageActiveIndicators() {
  var oFilterBar = document.querySelector('.shopify-app-block .boost-sd-left');
  if(oFilterBar) {
    oFilterBar.addEventListener('click', function () {
      requestAnimationFrame(checkFilterPageActiveIndicators);
    });
    checkFilterPageActiveIndicators();
  } else {
    setTimeout(setFilterPageActiveIndicators, 500);
  }
}

function checkFilterPageActiveIndicators() {
  var oFilterTabs = document.querySelectorAll('.shopify-app-block .boost-sd__filter-option');

  for (let i = 0; oFilterTabs[i]; i++) {
    if (oFilterTabs[i].querySelector('.boost-sd__filter-option-item-amount--selected')) {
      oFilterTabs[i].classList.add('hasActive');
    } else {
      oFilterTabs[i].classList.remove('hasActive');
    }
  }
}

function toggleLaptopMainMenu() {
  this.classList.toggle('open');
  document.querySelector('.cc-header header .main-menu').classList.toggle('open');
}

function addCollectionPromoCard() {
  // promo cards for specific collections add to the product grid
  var i = 0, collectionName = document.querySelectorAll('.breadcrumbs .breadcrumbs-list__link'),
      oProductGrid = document.querySelector('.shopify-app-block .boost-sd-layout .boost-sd-right .boost-sd__product-list')

  // app can be delayed in loading so keep rechecking until its loaded
  if (!collectionName || !oProductGrid) {
    setTimeout(addCollectionPromoCard, 500);
    return;
  }
  
  collectionName = collectionName[collectionName.length - 1].href;

  while(oPromoCollectionSection.children[i]) {
    var promoCollection = oPromoCollectionSection.children[i].getAttribute('collection').toLowerCase();

    if(collectionName.includes(promoCollection)) {
      var oPromoItem = oPromoCollectionSection.children[i],
        cardPosition = oPromoItem.getAttribute('cardPosition');//parseInt(oPromoItem.getAttribute('cardPosition'));

      cardPosition = parseInt(cardPosition) - 1;
      if (oProductGrid.children[cardPosition]) {
        oProductGrid.insertBefore(oPromoItem, oProductGrid.children[cardPosition]);
      } else {
        oProductGrid.appendChild(oPromoItem); 
      }
      i--;
    }
    
    i++;
  }

  // rename season so user friendly text
  var oSeasonContainer = document.querySelectorAll('.boost-sd__filter-option');
  
  oSeasonContainer = oSeasonContainer[oSeasonContainer.length - 1];
  oSeasonContainer = oSeasonContainer.querySelectorAll('.boost-sd__filter-option-item-label');
  
  for (let i = 0; oSeasonContainer[i]; i++) {
    oSeasonContainer[i].innerText = oSeasonContainer[i].innerText.replace("-", " "); 
  } 
}
  
function mainMenuMobileSwap() {
    if (window.innerWidth > 1023 && !oHeaderMainMenu.classList.contains('desktop-menu')) {
      oHeaderMainMenu.classList.add('desktop-menu');
      oHeaderMainMenu.classList.remove('mobile-menu');
      oHeaderMainMenu.classList.add('is-open');
      oHeaderMainMenu.setAttribute('open', '');
      
    } else if (window.innerWidth < 1024 && !oHeaderMainMenu.classList.contains('mobile-menu')) {
      oHeaderMainMenu.classList.remove('desktop-menu');
      oHeaderMainMenu.classList.add('mobile-menu');
      oHeaderMainMenu.classList.remove('is-open');
      oHeaderMainMenu.removeAttribute('open');

      // needed cause it readds for some reason
      setTimeout(function() {
        oHeaderMainMenu.removeAttribute('open');
        oHeaderMainMenu.classList.remove('is-open');
      },50)
    }
}

function setCollapsibleItems() {
  var oTabs = document.querySelectorAll('.cc-horizontal-tabs .heading-block');
  console.log(oTabs);
  for (let i = 0; oTabs[i]; i++) {
    oTabs[i].addEventListener('click', function () {
      if (this.classList.contains('active')) return; 
      var identifier = this.getAttribute('tabToggle'),
          oContent = document.querySelector('.cc-horizontal-tabs .content-container [tabToggle="'+identifier+'"]'),
          i = 0;

      // remove old active
      var oPrevActive = document.querySelectorAll('.cc-horizontal-tabs .tabs-section .active');
      while (oPrevActive[i]) {
        oPrevActive[i].classList.remove('active');
        i++;
      }
      
      // set new active
      this.classList.add('active');
      oContent.classList.add('active');
    });
  } 
}

window.addEventListener('DOMContentLoaded', init);